// deps
import React, { ReactElement, memo } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// components
import PaymentMethodIcon from "@payment-ui/widgets/payment-method-icon/PaymentMethodIcon";

// test-ids
import { LINK_ACCOUNT_VIEW_TEST_IDS } from "@swiggy-private/payment-test-ids";

import styles from "../LinkAccountView.v4.scss";

const ICON_WIDTH = 40;

interface HeaderProps {
    iconUrl: string;
    title: string;
    mobile: string;
}
/**
 * Renders Header component
 * @param props HeaderProps - contains method Data and user mobile
 * @returns ReactElement - HeaderComponent
 */
function Header(props: HeaderProps): ReactElement {
    return (
        <div className={styles.verifyOtpHeader} data-testid={LINK_ACCOUNT_VIEW_TEST_IDS.HEADER}>
            <div>
                <Text
                    variant="V2.subheading1.neutral.bold"
                    color="text_Highest_Emphasis"
                    data-testid={LINK_ACCOUNT_VIEW_TEST_IDS.TITLE}
                >
                    {props.title}
                </Text>
                <Text
                    variant="V2.body2.neutral.medium"
                    color="text_Highest_Emphasis"
                    className={styles.verifyOtpHeaderSubtitle}
                    data-testid={LINK_ACCOUNT_VIEW_TEST_IDS.SUB_TITLE}
                >
                    {props.mobile}
                </Text>
            </div>
            <PaymentMethodIcon
                parentClassName={styles.verifyOtpHeaderIcon}
                src={props.iconUrl}
                width={ICON_WIDTH}
                data-testid={LINK_ACCOUNT_VIEW_TEST_IDS.METHOD_ICON}
            />
        </div>
    );
}

export default memo(Header);
